// extracted by mini-css-extract-plugin
module.exports = {"menuFontColor":"rgba(255,255,255,.7)","menuHoverFontColor":"#fff","menuBackgroundColor":"#191a23"};